import Subscribe from "../../../src/components/subscribe";
import SocialIcons from "../../../src/components/socialIcons";
import { Link } from "react-router-dom";
import FooterMenuAccordion from "./footerMenu";

export default function Footer() {
  const brandsList = [
    {
      id: 502,
      name: "ALTERNA",
      link: "/shop/category/502/ALTERNA",
    },
    {
      id: 368,
      name: "KERASTASE",
      link: "/shop/category/368/KERASTASE",
    },

    // {
    //   id: 500,
    //   name: "AMADEUS SABRA",
    //   link: "/shop/category/500/AMADEUS SABRA",
    // },
    // {
    //   id: 501,
    //   name: "LOREAL",
    //   link: "/shop/category/501/LOREAL",
    // },

    // {
    //   id: 503,
    //   name: "OCEAN WAVE BRAIDS",
    //   link: "/shop/category/503/OCEAN WAVE BRAIDS",
    // },
    // {
    //   id: 504,
    //   name: "KHAN EL SABOUN",
    //   link: "/shop/category/504/KHAN EL SABOUN",
    // },
    // {
    //   id: 437,
    //   name: "SCHWARZKOPF",
    //   link: "/shop/category/437/SCHWARZKOPF",
    // },
  ];
  return (
    <div
      id="footer"
      className="z-30 bg-white dark:bg-neutral-900 pr-10 pl-10 pb-5 flex flex-col justify-between gap-20 border-t pt-12 dark:border-t-neutral-800 font-montserrat"
    >
      {" "}
      <div className="flex justify-center items-center sm:flex-row flex-col gap-2">
        <img
          src="/logo.png"
          alt="amadeus-logo"
          className="w-32 dark:invert -ml-2"
        />
        <div className="flex flex-col gap-2 w-full items-start">
          <h6 className="sm:text-md text-sm font-light">
            Subscribe to our newsletter!
          </h6>
          <p className="text-[10px] text-neutral-600 ">
            You may{" "}
            <Link to="" className="hover:underline">
              unsubscribe
            </Link>{" "}
            at any time.{" "}
          </p>
          <Subscribe />
        </div>
      </div>
      <div className="flex flex-wrap lg:flex-nowrap justify-between sm:gap-y-20 sm:gap-10 gap-5 w-full text-neutral-600 dark:text-neutral-100">
        <div className="flex flex-col gap-5 lg:w-1/5 w-1/3 sm:flex hidden">
          <h6 className="font-montserrat font-medium text-md">
            BRANDS
          </h6>
          <div className="flex flex-col gap-2 text-[12px]">
            {brandsList?.map((brand) => (
              <Link
                key={brand.id}
                to={`/shop/category/${
                  brand.id
                }/${encodeURIComponent(brand.name)}`}
                className="hover:translate-x-2 duration-300"
              >
                {brand.name.toLocaleUpperCase()}
              </Link>
            ))}
          </div>
        </div>
        <FooterMenuAccordion
          title="BRANDS"
          items={brandsList}
        />
        <div className="flex flex-col gap-5 lg:w-1/5 w-1/2 sm:flex hidden">
          <h6 className="font-montserrat font-medium text-md">
            HAIR CARE
          </h6>
          <div className="flex flex-col gap-2 text-[12px]">
            <Link
              to="/shop/category/488/DRY SHAMPOOS"
              className="hover:translate-x-2 duration-300"
            >
              DRY SHAMPOOS
            </Link>
            <Link
              to="/shop/category/373/CONDITIONERS"
              className="hover:translate-x-2 duration-300"
            >
              CONDITIONERS
            </Link>
            <Link
              to="/shop/category/371/HAIR MASK"
              className="hover:translate-x-2 duration-300"
            >
              HAIR MASK
            </Link>
            <Link
              to="/shop/category/366/HAIR OILS AND SERUMS"
              className="hover:translate-x-2 duration-300"
            >
              HAIR OILS AND SERUMS
            </Link>
            <Link
              to="/shop/category/375/SHAMPOOS"
              className="hover:translate-x-2 duration-300"
            >
              SHAMPOOS
            </Link>
            <Link
              to="/shop/category/378/STYLING"
              className="hover:translate-x-2 duration-300"
            >
              STYLING
            </Link>
            <Link
              to="/shop/category/410/TREATMENTS"
              className="hover:translate-x-2 duration-300"
            >
              TREATMENTS
            </Link>
          </div>
        </div>
        <FooterMenuAccordion
          title="HAIR CARE"
          items={[
            {
              id: 1,
              name: "DRY SHAMPOOS",
              link: "/shop/category/488/DRY SHAMPOOS",
            },
            {
              id: 2,
              name: "CONDITIONERS",
              link: "/shop/category/373/CONDITIONERS",
            },
            {
              id: 3,
              name: "HAIR MASK",
              link: "/shop/category/371/HAIR MASK",
            },
            {
              id: 4,
              name: "HAIR OILS AND SERUMS",
              link: "/shop/category/366/HAIR OILS AND SERUMS",
            },
            {
              id: 5,
              name: "SHAMPOOS",
              link: "/shop/category/375/SHAMPOOS",
            },
            {
              id: 6,
              name: "STYLING",
              link: "/shop/category/378/STYLING",
            },
            {
              id: 7,
              name: "TREATMENTS",
              link: "/shop/category/410/TREATMENTS",
            },
          ]}
        />
        {/* <div className="flex flex-col gap-5 lg:w-1/5 w-1/2 sm:flex hidden">
          <h6 className="font-montserrat font-medium text-md">
            HAIR CONCERN
          </h6>
          <div className="flex flex-col gap-2 text-[12px]">
            <Link
              to="/shop/category/494/ANTI DANDRUFF"
              className="hover:translate-x-2 duration-300"
            >
              ANTI DANDRUFF
            </Link>
            <Link
              to="/shop/category/398/COARSE HAIR"
              className="hover:translate-x-2 duration-300"
            >
              COARSE HAIR
            </Link>
            <Link
              to="/shop/category/493/COLORED HAIR"
              className="hover:translate-x-2 duration-300"
            >
              COLORED HAIR
            </Link>
            <Link
              to="/shop/category/495/CURLY HAIR"
              className="hover:translate-x-2 duration-300"
            >
              CURLY HAIR
            </Link>
            <Link
              to="/shop/category/492/DAMAGED HAIR"
              className="hover:translate-x-2 duration-300"
            >
              DAMAGED HAIR
            </Link>
            <Link
              to="/shop/category/491/DRY HAIR"
              className="hover:translate-x-2 duration-300"
            >
              DRY HAIR
            </Link>
            <Link
              to="/shop/category/496/DULL HAIR"
              className="hover:translate-x-2 duration-300"
            >
              DULL HAIR
            </Link>
            <Link
              to="/shop/category/497/FRIZZY & UNRULY HAIR"
              className="hover:translate-x-2 duration-300"
            >
              FRIZZY & UNRULY HAIR
            </Link>
            <Link
              to="/shop/category/490/HAIR FALL"
              className="hover:translate-x-2 duration-300"
            >
              HAIR FALL
            </Link>
            <Link
              to="/shop/category/517/HEAT PROTECTION"
              className="hover:translate-x-2 duration-300"
            >
              HEAT PROTECTION
            </Link>
            <Link
              to="/shop/category/499/VOLUMIZING & THIKENING"
              className="hover:translate-x-2 duration-300"
            >
              VOLUMIZING & THIKENING
            </Link>
          </div>
        </div>
        <FooterMenuAccordion
          title="HAIR CONCERN"
          items={[
            {
              id: 494,
              name: "ANTI DANDRUFF",
              link: "/shop/category/494/ANTI DANDRUFF",
            },
            {
              id: 398,
              name: "COARSE HAIR",
              link: "/shop/category/398/COARSE HAIR",
            },
            {
              id: 493,
              name: "COLORED HAIR",
              link: "/shop/category/493/COLORED HAIR",
            },
            {
              id: 495,
              name: "CURLY HAIR",
              link: "/shop/category/495/CURLY HAIR",
            },
            {
              id: 492,
              name: "DAMAGED HAIR",
              link: "/shop/category/492/DAMAGED HAIR",
            },
            {
              id: 491,
              name: "DRY HAIR",
              link: "/shop/category/491/DRY HAIR",
            },
            {
              id: 496,
              name: "DULL HAIR",
              link: "/shop/category/496/DULL HAIR",
            },
            {
              id: 497,
              name: "FRIZZY & UNRULY HAIR",
              link: "/shop/category/497/FRIZZY & UNRULY HAIR",
            },
            {
              id: 490,
              name: "HAIR FALL",
              link: "/shop/category/490/HAIR FALL",
            },
            {
              id: 517,
              name: "HEAT PROTECTION",
              link: "/shop/category/517/HEAT PROTECTION",
            },
            {
              id: 499,
              name: "VOLUMIZING & THIKENING",
              link: "/shop/category/499/VOLUMIZING & THIKENING",
            },
          ]}
        /> */}

        <div className="flex flex-col gap-5 lg:w-1/5 w-1/3 sm:flex hidden">
          <h6 className="font-montserrat font-medium text-md">
            MENU
          </h6>
          <div className="flex flex-col gap-2 text-[12px]">
            <Link
              to="/"
              className="hover:translate-x-2 duration-300"
            >
              HOME
            </Link>
            <Link
              to="/shop"
              className="hover:translate-x-2 duration-300"
            >
              SHOP
            </Link>
            <Link
              to="/services"
              className="hover:translate-x-2 duration-300"
            >
              SERVICES
            </Link>
            <Link
              to="/about"
              className="hover:translate-x-2 duration-300"
            >
              ABOUT
            </Link>
            <Link
              to="/contact"
              className="hover:translate-x-2 duration-300"
            >
              CONTACT
            </Link>
          </div>
        </div>
        <FooterMenuAccordion
          title="MENU"
          items={[
            {
              id: 1,
              name: "HOME",
              link: "/",
            },
            {
              id: 2,
              name: "SHOP",
              link: "/shop",
            },
            {
              id: 3,
              name: "SERVICES",
              link: "/services",
            },
            {
              id: 4,
              name: "ABOUT",
              link: "/about",
            },
            {
              id: 5,
              name: "CONTACT",
              link: "/contact",
            },
          ]}
        />
        <div className="flex flex-col gap-5 lg:w-1/5 w-1/3 sm:flex hidden">
          <h6 className="font-montserrat font-medium text-md">
            ACCOUNT
          </h6>
          <div className="flex flex-col gap-2 text-[12px]">
            <Link
              to="/profile"
              className="hover:translate-x-2 duration-300"
            >
              PROFILE
            </Link>
            <Link
              to="/cart"
              className="hover:translate-x-2 duration-300"
            >
              CART
            </Link>
            <Link
              to="/wishlist"
              className="hover:translate-x-2 duration-300"
            >
              WISHLIST
            </Link>
          </div>
        </div>
        <FooterMenuAccordion
          title="ACCOUNT"
          items={[
            {
              id: 1,
              name: "PROFILE",
              link: "/profile",
            },
            {
              id: 2,
              name: "CART",
              link: "/cart",
            },
            {
              id: 3,
              name: "WISHLIST",
              link: "/wishlist",
            },
          ]}
        />
        <FooterMenuAccordion
          title="POLICIES"
          items={[
            {
              id: 0,
              name: "CAREERS",
              link: "/careers",
            },
            {
              id: 1,
              name: "PRIVACY POLICIES",
              link: "/privacy-policies",
            },
            {
              id: 2,
              name: "TERMS & CONDITIONS",
              link: "/terms-and-conditions",
            },
            {
              id: 3,
              name: "DELIVERY & SHIPPING",
              link: "/delivery-and-shipping",
            },
            {
              id: 4,
              name: "REFUND & EXCHANGE",
              link: "/refund-and-exchange",
            },
          ]}
        />
      </div>
      <div className=" flex sm:flex-row gap-20 flex-col justify-between items-center w-full sm:h-fit pt-5 border-t">
        <div className="flex-row gap-20 text-[12px] sm:flex hidden w-full">
          <Link
            to={"/careers"}
            className="hover:translate-x-2 duration-300 w-fit"
          >
            CAREERS
          </Link>
          <Link
            to={"/privacy-policies"}
            className="hover:translate-x-2 duration-300 w-fit"
          >
            PRIVACY POLICIES
          </Link>
          <Link
            to="/terms-and-conditions"
            className="hover:translate-x-2 duration-300 w-fit"
          >
            TERMS OF SERVICE
          </Link>
          <Link
            to="/delivery-and-shipping"
            className="hover:translate-x-2 duration-300 w-fit"
          >
            DELIVERY & SHIPPING
          </Link>
          <Link
            to="/refund-and-exchange"
            className="hover:translate-x-2 duration-300 w-fit"
          >
            REFUND & EXCHANGE
          </Link>
        </div>
        <SocialIcons />
      </div>
    </div>
  );
}
